import { contactInfo } from '../data/portfolioData';
import { Mail, Phone, MapPin, Github, Linkedin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-primary">Me contacter</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            N'hésitez pas à me contacter pour discuter de projets, d'opportunités ou simplement échanger
          </p>
        </div>
        
        {/* Conteneur principal centré */}
        <div className="flex flex-col items-center justify-center">
          
          {/* Section des moyens de contact - Centrée */}
          <div className="w-full max-w-4xl mx-auto mb-16">
            <h3 className="text-3xl font-bold mb-8 text-center">Prendre contact</h3>
            
            {/* Grille pour les 3 moyens de contact */}
            <div className="grid md:grid-cols-3 gap-8">
              {/* Email */}
              <div className="flex flex-col items-center text-center p-6 bg-gray-800/30 rounded-2xl border border-gray-700 hover:border-primary transition-all duration-300">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                  <Mail className="text-primary" size={28} />
                </div>
                <h4 className="text-xl font-semibold mb-2">Email</h4>
                <p className="text-gray-400 mb-3">{contactInfo.email}</p>
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="text-primary hover:text-secondary font-medium transition-colors"
                >
                  Envoyer un email
                </a>
              </div>
              
              {/* Téléphone */}
              <div className="flex flex-col items-center text-center p-6 bg-gray-800/30 rounded-2xl border border-gray-700 hover:border-primary transition-all duration-300">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                  <Phone className="text-primary" size={28} />
                </div>
                <h4 className="text-xl font-semibold mb-2">Téléphone</h4>
                <p className="text-gray-400 mb-3">{contactInfo.phone}</p>
                <a 
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="text-primary hover:text-secondary font-medium transition-colors"
                >
                  Appeler
                </a>
              </div>
              
              {/* Localisation */}
              <div className="flex flex-col items-center text-center p-6 bg-gray-800/30 rounded-2xl border border-gray-700 hover:border-primary transition-all duration-300">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                  <MapPin className="text-primary" size={28} />
                </div>
                <h4 className="text-xl font-semibold mb-2">Localisation</h4>
                <p className="text-gray-400 mb-3">{contactInfo.location}</p>
                <p className="text-gray-500 text-sm">Disponible pour des opportunités</p>
              </div>
            </div>
          </div>
          
          {/* Section des réseaux sociaux - Centrée */}
          <div className="w-full max-w-2xl mx-auto">
            <h4 className="text-2xl font-semibold mb-8 text-center">Réseaux sociaux</h4>
            <div className="flex justify-center gap-6">
              <a 
                href={contactInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col items-center"
              >
                <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mb-3 group-hover:bg-primary transition-all duration-300 group-hover:scale-110">
                  <Github size={28} />
                </div>
                <span className="text-gray-400 group-hover:text-primary transition-colors">GitHub</span>
              </a>
              
              <a 
                href={contactInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col items-center"
              >
                <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mb-3 group-hover:bg-primary transition-all duration-300 group-hover:scale-110">
                  <Linkedin size={28} />
                </div>
                <span className="text-gray-400 group-hover:text-primary transition-colors">LinkedIn</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;